import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Paper, Grid, Typography, Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import updateState from '../actions/updateState';

const useStyles = makeStyles({
  paper1: {
    transform: 'translateY(70%) translateX(-40%) rotate(40deg) ',
    margin: 0,
    background: 'linear-gradient(#373737, #646464, #373737)',
  },
  paper2: {
    transform: 'translateX(-110%) translateY(40%) rotate(-20deg)',
    background: 'linear-gradient(#CD272F, #F94A03, #CD272F)',
  },
  qCash: {
    color: '#D3D3D3',
    transform: 'translateX(23%) translateY(490%) rotate(93deg)',
  },
  creditCard: {
    color: '#D3D3D3',
    transform: 'translateX(38%) translateY(415%) rotate(91deg)',
  },
});

const DesignAndLanguages = ({ disableDesign, showLanguages }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const language = useSelector((state) => state.formState.Page_language);

  return (
    <div>
      <Grid container>
        <Grid container item xs={6}>
          <Grid item xs={6}>
            {' '}
            <Paper
              className={classes.paper1}
              style={
                disableDesign
                  ? {
                      width: 180,
                      height: 180,
                      visibility: 'hidden',
                    }
                  : {
                      width: 180,
                      height: 180,
                    }
              }
            />
          </Grid>
          <Grid item xs={6}>
            {' '}
            <Paper
              className={classes.paper2}
              style={
                disableDesign
                  ? {
                      width: 200,
                      height: 200,
                      visibility: 'hidden',
                    }
                  : { width: 200, height: 200 }
              }
            >
              {' '}
              <Typography variant="body1" className={classes.creditCard}>
                Empowering Restaurants
              </Typography>
              <Typography className={classes.qCash}>with qMenu</Typography>
            </Paper>
          </Grid>
        </Grid>
        <Grid item xs={6} justify="center" alignItems="center" container>
          <Box mt={5}>
            {' '}
            {showLanguages ? (
              <>
                {' '}
                <Button
                  onClick={() => {
                    dispatch(updateState({ Page_language: 'English' }));
                  }}
                  color={language === 'English' ? 'primary' : 'secondary'}
                >
                  <u>English </u>
                </Button>
                <Button
                  onClick={() => {
                    dispatch(updateState({ Page_language: 'Chinese' }));
                  }}
                  color={language === 'Chinese' ? 'primary' : 'secondary'}
                >
                  {' '}
                  <u>中文 </u>
                </Button>{' '}
              </>
            ) : null}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default DesignAndLanguages;
